import React from "react";
import { useAuthentication } from "../../../../context/authentication";
import { useCommissionTemplates } from "../../../../context/commissionTemplates";
import { DottedMenu } from "../../../../context/dropdownMenu/DropdownMenuProvider";
import { CommissionTemplate } from "../../../../utils/types";

interface Props {
  disabled?: boolean;
  commissionTemplate: CommissionTemplate;
  toggleEditCommissionForm: (
    commissionTemplate: CommissionTemplate | undefined
  ) => void;
}

const CommissionTemplateActionsButton: React.FC<Props> = ({
  disabled,
  commissionTemplate,
  toggleEditCommissionForm
}) => {
  const { wrapActionWithAuth } = useAuthentication();
  const { removeCommissionTemplate } = useCommissionTemplates();

  return (
    <DottedMenu
      text="Open commission template actions"
      disabled={disabled}
      menuItems={[
        {
          text: "Edit",
          onClick: wrapActionWithAuth(() => {
            toggleEditCommissionForm(commissionTemplate);
          })
        },
        {
          text: "Remove",
          onClick: wrapActionWithAuth(() => {
            removeCommissionTemplate(commissionTemplate.uuid);
          })
        }
      ]}
    />
  );
};

export default CommissionTemplateActionsButton;
